// extracted by mini-css-extract-plugin
export var base = "_3i-0";
export var updateBanner = "_3i-1";